import automationImage from "../assets/img/3ds/automatization.webp";
import bootcampImage from "../assets/img/3ds/mentorship.jpg";
import productImage from "../assets/img/3ds/sites.jpg";
import platformImage from "../assets/img/3ds/platforme.png";
import webImage from "../assets/img/3ds/sites.png";
import consultingImage from "../assets/img/3ds/telework-6795505_1280.jpg";

export const services = [
   {
      id: "automation",
      slug: "automation",
      accent: "b",
      image: automationImage,
      translationKey: "services.items.automation",
   },
   {
      id: "platforms",
      slug: "custom-web-platforms",
      accent: "r",
      image: platformImage,
      translationKey: "services.items.platforms",
   },
   {
      id: "websites",
      slug: "websites-digital-presence",
      accent: "g",
      image: webImage,
      translationKey: "services.items.websites",
   },
   {
      id: "design",
      slug: "ui-ux-product-design",
      accent: "b",
      image: productImage,
      translationKey: "services.items.design",
   },
   {
      id: "courses",
      slug: "ai-automation-courses",
      accent: "r",
      image: bootcampImage,
      translationKey: "services.items.courses",
   },
   {
      id: "consulting",
      slug: "digital-strategy-consulting",
      accent: "g",
      image: consultingImage,
      translationKey: "services.items.consulting",
   },
];

export const getServiceBySlug = (slug) =>
   services.find((service) => service.slug === slug);
